//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class PagedResponseOfLocalizedEntity {
    items : LocalizedEntity[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class PagedRequestVM {
    paging : PagingFilter;
    sortBy : SortByParameter;
    filter : { [key: string]: string[]; };

    constructor() 
    {
    	            this.paging = new PagingFilter();
                this.sortBy = new SortByParameter();
                this.filter = {};
        }
}

export class PagingFilter {
    currentPage : number;
    itemsPerPage : number;
    skip : number;
    take : number;

    constructor() 
    {
    	            this.currentPage = null ;
                this.itemsPerPage = null ;
                this.skip = null ;
                this.take = null ;
        }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
    	            this.propertyName = "" ;
                this.ascending = false ;
        }
}

export class StageVM {
    identifier : string;
    title : LocalizedValue;
    hint : LocalizedValue;
    imageUrl : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.title = new LocalizedValue();
                this.hint = new LocalizedValue();
                this.imageUrl = "" ;
        }
}

export class GalleryItemVM {
    attachmentIdentifier : string;
    imageUrl : string;
    thumbImageUrl : string;
    capturedOn : string ;

    constructor() 
    {
    	            this.attachmentIdentifier = "" ;
                this.imageUrl = "" ;
                this.thumbImageUrl = "" ;
                this.capturedOn = null;
        }
}

export class SimpleEntity {
    identifier : string;

    constructor() 
    {
    	            this.identifier = "" ;
        }
}

export class BaseEntity extends SimpleEntity {
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class UserGameResume extends BaseEntity {
    userIdentifier : string;
    name : string;
    surname : string;
    stagesDone : UserStage[];
    completedOn : string ;
    giftCashedOn : string ;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.stagesDone = [];
                this.completedOn = null;
                this.giftCashedOn = null;
        }
}

export class UserStage {
    stageIdentifier : string;
    stageTitle : LocalizedValue;
    completedOn : string ;

    constructor() 
    {
    	            this.stageIdentifier = "" ;
                this.stageTitle = new LocalizedValue();
                this.completedOn = null;
        }
}

export class InternalUserVM {
    preferredCulture : string;
    emailAddress : string;
    identifier : string;
    username : string;
    role : string;
    token : string;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.preferredCulture = "" ;
                this.emailAddress = "" ;
                this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class DashboardVM {
    registeredUser : number;
    englishUsers : number;
    photosTaken : number;
    rankedPeople : number;
    foundAtLeastOneStagePeople : number;
    wristTaken : number;
    welcomeKitTaken : number;
    giftTaken : number;
    photoDownload : number;
    photoShared : number;

    constructor() 
    {
    	            this.registeredUser = null ;
                this.englishUsers = null ;
                this.photosTaken = null ;
                this.rankedPeople = null ;
                this.foundAtLeastOneStagePeople = null ;
                this.wristTaken = null ;
                this.welcomeKitTaken = null ;
                this.giftTaken = null ;
                this.photoDownload = null ;
                this.photoShared = null ;
        }
}

export class TextIdentifier {
    text : string;
    identifier : string;

    constructor() 
    {
    	            this.text = "" ;
                this.identifier = "" ;
        }
}

export class Address {
    name : string;
    typedAddress : string;
    streetNumber : string;
    route : string;
    locality : string;
    province : string;
    region : string;
    country : string;
    countryCode : string;
    postalCode : string;
    latitude : number;
    longitude : number;
    completeAddress : string;

    constructor() 
    {
    	            this.name = "" ;
                this.typedAddress = "" ;
                this.streetNumber = "" ;
                this.route = "" ;
                this.locality = "" ;
                this.province = "" ;
                this.region = "" ;
                this.country = "" ;
                this.countryCode = "" ;
                this.postalCode = "" ;
                this.latitude = null ;
                this.longitude = null ;
                this.completeAddress = "" ;
        }
}

export class TextIdentifierVM {
    identifier : string;
    text : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.text = "" ;
        }
}

export class BaseApiLoginResponse {
    identifier : string;
    username : string;
    role : string;
    token : string;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class BaseCredential {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class LanguageCredential extends BaseCredential {
    preferredCulture : string;

    constructor() 
    {
    	        super();
		            this.preferredCulture = "" ;
        }
}

export class RefreshTokenResponse {
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class AuthResponse extends RefreshTokenResponse {
    token : string;

    constructor() 
    {
    	        super();
		            this.token = "" ;
        }
}

export class LoggedUserVM extends InternalUserVM {
    completeName : string;
    isOwner : boolean;
    secretWp : string;

    constructor() 
    {
    	        super();
		            this.completeName = "" ;
                this.isOwner = false ;
                this.secretWp = "" ;
        }
}

export class BaseUser extends BaseEntity {
    loginData : LoginData;
    contactData : ContactData;
    personalData : PersonalData;
    preferredCulture : string;
    disabledData : DisabledData;
    fcmId : string;

    constructor() 
    {
    	        super();
		            this.loginData = new LoginData();
                this.contactData = new ContactData();
                this.personalData = new PersonalData();
                this.preferredCulture = "" ;
                this.disabledData = new DisabledData();
                this.fcmId = "" ;
        }
}

export class AppUser extends BaseUser {
    userType : string;
    cardNumber : string;
    lastLogin : string ;
    wristPassTaken : string ;
    welocomeKitTaken : string ;

    constructor() 
    {
    	        super();
		            this.userType = "" ;
                this.cardNumber = "" ;
                this.lastLogin = null;
                this.wristPassTaken = null;
                this.welocomeKitTaken = null;
        }
}

export class LoginData extends BaseCredential {
    role : string;
    resetPassword : string;
    confirmationCode : string;
    confirmedOn : string ;

    constructor() 
    {
    	        super();
		            this.role = "" ;
                this.resetPassword = "" ;
                this.confirmationCode = "" ;
                this.confirmedOn = null;
        }
}

export class ContactData {
    phoneNumber : string;
    emailAddress : string;

    constructor() 
    {
    	            this.phoneNumber = "" ;
                this.emailAddress = "" ;
        }
}

export class PersonalData {
    name : string;
    surname : string;
    birthDate : string ;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.birthDate = null;
        }
}

export class DisabledData {
    disabledOn : string ;
    disabledBy : TextIdentifier;

    constructor() 
    {
    	            this.disabledOn = null;
                this.disabledBy = new TextIdentifier();
        }
}

export class UpdateUserInfoVM {
    identifier : string;
    id : string;
    name : string;
    surname : string;
    email : string;
    type : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.id = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.type = "" ;
        }
}

export class InternalUserEditVM {
    identifier : string;
    email : string;
    password : string;
    name : string;
    preferredCulture : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.email = "" ;
                this.password = "" ;
                this.name = "" ;
                this.preferredCulture = "" ;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}